import { render, staticRenderFns } from "./modalVerComision.vue?vue&type=template&id=0b4376e0"
import script from "./modalVerComision.vue?vue&type=script&lang=js"
export * from "./modalVerComision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports